.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.infoText {
  color: var(--body-text-arrows-400);
}

#local-sandbox-instance-form-field {
  margin-left: calc(var(--spacer) * 3.3);
}

.form-field-info-text {
  padding-left: calc(var(--spacer) * 3.3);
  padding-top: calc(var(--spacer) * 2);
}

.section {
  margin-top: calc(var(--spacer) * 4);
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
}

gz-dropdown {
  --form-field-input-width: 400px;
}

gz-text + gz-form-field {
  margin-top: calc(var(--spacer) * 2.5);
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    padding-right: 20px;
  }

  gz-text {
    width: fit-content;
    padding: 0 20px 20px 20px;
  }

  gz-text + gz-form-field {
    margin-top: 0;
  }
}
